import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import './Auth.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      const auth = getAuth();
      // Sign in directly with Firebase using email/password
      await signInWithEmailAndPassword(auth, email, password);

      // Redirect back to the page the user was trying to access (e.g. /settings?fitbit=connected)
      const from = (location.state as any)?.from;
      navigate(from ? `${from.pathname}${from.search}${from.hash}` : '/settings', { replace: true });
    } catch (err) {
      console.error('Login error (frontend):', err);
      setError('Invalid email or password');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <Link to="/" className="auth-logo">
          <img src="/mosaic-icon.png" alt="mosaime" className="logo-icon-img" />
          <span className="logo-text">mosaime</span>
        </Link>

        <div className="auth-card">
          <h1>Welcome Back</h1>
          <p className="auth-subtitle">Log in to continue your wellness journey</p>

          {error && <div className="auth-error">{error}</div>}

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
              />
            </div>

            <button type="submit" className="btn btn-primary btn-full" disabled={isLoading}>
              {isLoading ? 'Logging in...' : 'Log In'}
            </button>
          </form>

          <p className="auth-footer">
            <Link to="/forgot-password">Forgot your password?</Link>
          </p>
          <p className="auth-footer">
            Don't have an account? <Link to="/signup">Sign up</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;